<template>
  <div class="grade_caifu" id="tdcfdj">
    <topNav typeName vuePage="#tdcfdj" title="Ta的财富等级" back="1" closeweb="1"></topNav>
    <!-- 顶部用户信息的  进度条的组件 -->
    <gradecom
      :myriches="myriches"
      :probgcolor="probgcolor"
      :probgcolora="probgcolora"
      :prowidth="prowidth"
      :caifu="caifu"
      :expname="expname"
    />
    <!-- 等级特权 -->
    <gradetequan :gradeLists="gradeLists" />

    <p class="info_box">说明： 高财富等级拥有低等级所有特权，更多特权敬请期待。</p>
    <div class="btn_box relativeItem">
      <p class="btn absoluteItem" @click="gogradecaifuts()">提升我的财富等级</p>
    </div>
  </div>
</template>










<script>
import Gradecom from "./gradecaifucom";
import Gradetequan from "./gradetequan";
import topNav from "../index/top_nav";

export default {
  components: {
    Gradecom,
    Gradetequan,
    topNav,
  },
  data() {
    return {
      probgcolor: "rgb(255, 92, 54)",
      probgcolora: "rgba(255, 92, 54, .2)",
      prowidth: "", // 进度条的宽度  百分比
      myriches: {},
      gradeLists: [],
      caifu: "",
      expname: "财富值",
    };
  },
  methods: {
    gogradecaifuts() {
      this.$router.push({ path: "/gradecaifuts" });
    },
    getList() {
      let _this = this;
      let data = {
        type: 0,
      };
      //如果链接上有userID就进行管理操作
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.userid = this.$route.query.uid;
      }
      _this.$jsonp(_this.$apis("grade_level"), data, (res) => {
        _this.myriches = res.body.data.data.list;
        _this.prowidth = res.body.data.data.list.bilie * 100;
        if (_this.prowidth < 0) {
          _this.prowidth = 0;
        }
        if (_this.prowidth > 100) {
          _this.prowidth = 100;
        }
        _this.gradeLists = res.body.data.data.list.priviege;
        _this.caifu = res.body.data.data.list.levelname;
      });
    },

    /**设置顶部padding */
    set_top_padding() {
      let obj = document.querySelector("#tdcfdj");
      obj.style.paddingTop = this.padding_top + "px";
    },

    /**从ios获取设备topbar的高度 */
    getStatusBarHeight(val) {
      this.padding_top = val;
      let _this = this;
      setTimeout(() => {
        _this.set_top_padding();
      }, 400);
    },

    // 隐藏顶部的导航
    hideTopNav() {
      if (this.$tool.isAorI() == 'isiOS') {
        document.querySelector("#top_nav").style.display = 'none';
      }
    },
  },
  mounted() {
    //将getStatusBarHeight赋予window，便于app调用
    // window["getStatusBarHeight"] = (val) => {
    //   this.getStatusBarHeight(val);
    // };
    let _this = this;
    if (_this.$cookie.getC("platform") == "app" || _this.$tool.in_third) {
      //这个计时器是防止浏览器没有找到APP里面的get_top_bar_height方法
      //导致个别页面顶部会被遮住无法进行操作
      let js = setTimeout(() => {
        _this.set_top_padding();
      }, 500);
      _this.padding_top = _this.$appAc.get_top_bar_height();
      //如果浏览器找到了APP的get_top_bar_height方法
      //就立马清除计时器，导航高度使用app返回的值
      clearTimeout(js);
      if (_this.$tool.isAorI() == "Android") {
        setTimeout(() => {
          _this.set_top_padding();
        }, 400);
      }
    } else {
      setTimeout(() => {
        _this.set_top_padding();
      }, 400);
    }

    this.$tool.setTitle("Ta的财富等级");
    this.getList();
    //隐藏顶部的导航
    this.hideTopNav();
  },
};
</script>













<style scoped lang="scss">
.grade_caifu {
  background-color: #fff;
  min-height: 100vh;
  width: 100%;
}

.center_box {
  width: 90%;
  margin: 0 auto;
  padding-top: 20px;
  p {
    color: #616161;
    font-size: 14px;
  }
  li {
    margin: 40px 0;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 50px;
      height: 20px;
    }
    div {
      margin-left: 20px;
      font-size: 15px;
      color: #333;
      font-weight: 600;
    }
  }
}
.info_box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #f5f5f5;
  color: #999;
  font-size: 0.8rem;
}
.btn_box {
  height: 120px;
  width: 100%;
  background-color: #fff;
}
.btn {
  background-color: #ff4da4;
  color: #fff8fc;
  width: 200px;
  height: 50px;
  line-height: 50px;
  border-radius: 30px;
  text-align: center;
  font-size: 13px;
  margin: 0 auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>